/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/digitpass_private_corporate'
export default icon
